<template>
  <div class="page-container">
    <div class="remark mb-3">
      ส่ง sap รอบ:
      <div class="round">{{ fixHourTo23 }}</div>
    </div>
    <div class="report-container">
      <div class="report">
        <div
          v-for="(venderResendReport, index) in sapVenderResendReportPresenters"
          :key="index"
          :class="{ header: index === 0 }"
          class="vender-report-row"
        >
          <div class="report-cell">
            <pre class="report-billing">{{
              venderResendReport.receiptAddress
            }}</pre>
          </div>
          <div class="report-cell text-center">
            <router-link
              :to="{
                name: 'ReceiptDetailPage',
                params: {
                  id: venderResendReport.receiptId,
                },
              }"
              class="router-link"
              target="_blank"
              >{{ venderResendReport.receiptNumber }}</router-link
            >
          </div>
          <div class="report-cell">
            {{ venderResendReport.serviceName }}
          </div>
          <div class="report-cell">
            {{ venderResendReport.sapServiceType }}
          </div>
          <div class="report-cell">
            {{ venderResendReport.vendorName }}
          </div>
          <div class="report-cell">
            {{ venderResendReport.fulfilledAt }}
          </div>
          <div class="report-cell">
            {{ venderResendReport.receiptAppointmentDate }}
          </div>
          <div class="report-cell">
            {{ venderResendReport.receiptAppointmentNumber }}
          </div>
          <div class="report-cell">
            {{ venderResendReport.actualCost }}
          </div>
          <div class="report-cell">
            <router-link
              v-if="venderResendReport.appointmentId"
              :to="{
                name: 'AppointmentDetailPage',
                params: { id: venderResendReport.appointmentId },
              }"
              target="_blank"
              class="router-link"
              >กดเพื่อดูนัดหมาย</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon"
import { baanRueJaiClient } from "@/dependencies"
import { convertDateTimeToTimeText } from "@/lib/dateTime"
import { convertBathToStangAndRoundTwoDecimal } from "../../../lib/formatter"

export default {
  data() {
    return {
      sapVenderResendReports: [],
    }
  },
  computed: {
    sapVenderResendReportPresenters() {
      const header = {
        receiptAddress: "ข้อมูลที่ออกใบเสร็จ",
        receiptNumber: "เลขที่ใบเสร็จ",
        serviceName: "บริการ",
        sapServiceType: "ประเภทของสินค้าและบริการ (SAP)",
        vendorName: "ผู้ให้บริการรายนัดหมาย",
        fulfilledAt: "วันที่ปิดงาน",
        receiptAppointmentDate: "วันที่ใบเสร็จจาก Vendor",
        receiptAppointmentNumber: "เลขที่ใบเสร็จจาก Vendor",
        actualCost: "ต้นทุนจริง",
      }

      return [header, ...this.sapVenderResendReports]
    },
    fixHourTo23() {
      const currentDateTime = DateTime.local()

      let fixedDateTime
      if (currentDateTime.day === 1 && currentDateTime.hour < 12) {
        fixedDateTime = currentDateTime.set({
          hour: 12,
          minute: 0,
          second: 0,
          millisecond: 0,
        })
      } else {
        fixedDateTime = currentDateTime.set({
          hour: 23,
          minute: 0,
          second: 0,
          millisecond: 0,
        })

        if (currentDateTime.hour >= 23) {
          fixedDateTime = fixedDateTime.plus({ days: 1 })
        }
      }

      return convertDateTimeToTimeText(fixedDateTime)
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    async setupData() {
      await this.setupSapVenderResendReports()
    },
    async setupSapVenderResendReports() {
      const reports = await this.fetchSapVenderResendReports()

      this.sapVenderResendReports = reports.map((appoint) => ({
        ...appoint,
        receiptAddress: appoint.receipt_address,
        receiptNumber: appoint.subscription.receipt.document_number,
        serviceName: appoint.service.name,
        sapServiceType: appoint.service.sap_service_type,
        vendorName: appoint.provider.name,
        fulfilledAt: convertDateTimeToTimeText(
          appoint.fulfilled_at,
          "dd MMM yyyy",
        ),
        receiptAppointmentDate: convertDateTimeToTimeText(
          appoint.receipt_date,
          "dd MMM yyyy",
        ),
        receiptAppointmentNumber: appoint.receipt_number,
        actualCost: convertBathToStangAndRoundTwoDecimal(appoint.actual_cost),
        receiptId: appoint.subscription.receipt.id,
        receiptDate: appoint.receipt_date,
        appointmentId: appoint.id,
      }))
    },
    async fetchSapVenderResendReports() {
      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.appointments.getAppointmentForRecreateSapByEditedProvider()

        return response.data.result
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        return []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.report-container {
  padding: 0 0;
  width: 100%;
}

.vender-report-row {
  display: grid;
  grid-template-columns:
    450px
    200px
    450px
    250px
    350px
    230px
    230px
    250px
    200px
    200px
    200px;
}

.vender-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
    font-size: 16px;
  }
}

.report-cell {
  padding: 10px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);
}

.receipt-link {
  font-size: 16px;
}

.query-box {
  margin-bottom: 15px;
}

pre.report-billing {
  white-space: pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-family: sans-serif;
  font-size: 14pt;
  color: #4a4a4a;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.router-link {
  cursor: pointer;
  text-decoration: underline;
}

.remark {
  font-size: 22px;
  font-weight: bold;

  .round {
    color: red;
  }
}
</style>
